import SimpleStore from '../../../store/SimpleStore';
import { HTTP_URL_PARAMS } from '../../../utils/constants/HttpMethodsConstants';

const generateTvShowQueryParams = (id: string) => {
  const translation = SimpleStore.get(HTTP_URL_PARAMS.DISPLAY_LANGUAGE);
  const country = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
  const queryParams = {
    id,
    country,
    translation,
    collectionFilter: {
      page: 1,
      country,
      translation
    }
  };
  return queryParams;
};

export default generateTvShowQueryParams;
